"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayPeriodAbbrDto = instanceOfPayPeriodAbbrDto;
exports.PayPeriodAbbrDtoFromJSON = PayPeriodAbbrDtoFromJSON;
exports.PayPeriodAbbrDtoFromJSONTyped = PayPeriodAbbrDtoFromJSONTyped;
exports.PayPeriodAbbrDtoToJSON = PayPeriodAbbrDtoToJSON;
exports.PayPeriodAbbrDtoToJSONTyped = PayPeriodAbbrDtoToJSONTyped;
/**
 * Check if a given object implements the PayPeriodAbbrDto interface.
 */
function instanceOfPayPeriodAbbrDto(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    return true;
}
function PayPeriodAbbrDtoFromJSON(json) {
    return PayPeriodAbbrDtoFromJSONTyped(json, false);
}
function PayPeriodAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
    };
}
function PayPeriodAbbrDtoToJSON(json) {
    return PayPeriodAbbrDtoToJSONTyped(json, false);
}
function PayPeriodAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
    };
}
//# sourceMappingURL=PayPeriodAbbrDto.js.map